var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderOpened = function SvgFolderOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.458 9.75V8.625c0-1.243-.977-2.25-2.183-2.25h-4.871c-.365 0-.706-.188-.908-.5L9.962 3.501A1.08 1.08 0 0 0 9.054 3H4.182C2.977 3 2 4.007 2 5.25v14.46c0 .713.56 1.29 1.251 1.29m0 0c.553 0 1.04-.373 1.198-.92l2.54-8.726c.277-.953 1.127-1.604 2.09-1.604h10.737c1.457 0 2.505 1.442 2.094 2.883l-1.921 6.75c-.273.959-1.125 1.617-2.094 1.617z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgFolderOpened;